import React, { useEffect } from "react";
import { Badge, Avatar, Input, Comment, Col, Tooltip } from "antd";
import { BiCopy } from "react-icons/bi";
import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import { getImage } from "../../../../../../src/utilities/storageOperations/downloadURL";

const InterviewCard = (props) => {

  const [value, setValue] = useState(props.MeetingURL);
  const [copied, setCopied] = useState(false);
  const [imageUrl , setImageUrl] = useState('');

 useEffect(async () => {
  if (props?.user[0]?.Profiles?.PictureUrl) {
      setImageUrl(props?.user[0]?.Profiles?.PictureUrl)
    }
  }, [props]); 

  const onChange = (value) => {
    // this.setState({value, copied: false})
    setValue(value);
  };

  const onClick = ({ target: { innerHTML } }) => {
    setCopied(true);
  };

  const onCopy = () => {
    setCopied(true);
  };
  return (
    <>
      <div id = "interviewId" className="interview-card">
        <Comment
          className="comment-style"
          author={
          <Tooltip title={(props?.SkillListingTitle ? props?.SkillListingTitle : props?.JobTitle)?.slice(0, 100)}>
  <div className="interview-card-title" style={{ width: "100%" }}>
    {(props?.SkillListingTitle ? props?.SkillListingTitle : props?.JobTitle)?.slice(0, 100)}
    {(props?.SkillListingTitle || props?.JobTitle)?.length > 100 && '...'}
  </div>
</Tooltip>
          }
          avatar={
            // <Avatar src="https://joeschmoe.io/api/v1/random" alt="Han Solo" />
            <Avatar className="interview-card-image" src={`${process.env.REACT_APP_S3_URL}${imageUrl?.charAt(0) !== "/" ? '/' : ""}${imageUrl}`} alt="Han Solo" >
              <div className='dp-text'>{props?.user[0]?.Profiles?.FirstName ? props?.user[0]?.Profiles?.FirstName.split("")[0].charAt(0).toUpperCase() : props?.user[0]?.UserName ? props?.user[0]?.UserName.split("")[0].charAt(0).toUpperCase() :  "C"}</div>
            </Avatar>
            // <Badge dot={true} status={"success" || "default"} >
            // </Badge>
          }
          content={
            <>
              <div className="interview-card-content">
                <div className="interview-card-candidate-name">{props?.user[0]?.Profiles?.FirstName ? `${props?.user[0]?.Profiles?.FirstName} ${props.user[0]?.Profiles?.LastName}` : props?.user[0]?.UserName ? props?.user[0]?.UserName : 'Candidate name N/A'}</div>
                <Tooltip title={props?.SkillListingTitle ? props?.JobTitle ? props?.JobTitle : "" : ""} >
                <div className="interview-card-candidate-jobtitle" style={{width: '100%'}} >{props?.SkillListingTitle ? props?.JobTitle ? props?.JobTitle : "" : ""}</div>
                </Tooltip>
                <div className="interview-card-time">
                  {moment(props?.ApprovedScheduledTiming?.StartTime).local().format("hh:mm A") +
                    " - " +
                    moment(props?.ApprovedScheduledTiming?.EndTime).local().format("hh:mm A")}
                </div>
              </div>
              <div>

              </div>
              {!props?.OnSite ?
              <Col xs={23}>
                <Input
                  readOnly
                  className="interview-input"
                  onChange={(e) => onChange(e.target.value)}
                  // value={value}
                  value={value}
                  suffix={
                    <CopyToClipboard onCopy={() => onCopy} text={value}>
                      <Tooltip title="copied" color={"green"}>
                        <BiCopy color="#888888" onClick={() => onClick} />
                      </Tooltip>
                    </CopyToClipboard>
                  }
                  // defaultValue='https://teams.microsoft.com/l/...'
                />
              </Col> : <span className="interviewCardLocationSpan">{props?.Location}</span>
          }
            </>
          }
        />
      </div>
    </>
  );
};
export default InterviewCard;
